import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import HeroBanner from './components/HeroBanner';
import CategoryTabs from './components/CategoryTabs';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, hotArticles, categories } from '@/mocks/articles';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredArticles = useMemo(() => {
    if (activeCategory === 'all') return articles;
    return articles.filter((a) => a.categorySlug === activeCategory);
  }, [activeCategory]);

  const topHotArticles = hotArticles.slice(0, 5);

  return (
    <>
      <title>吃瓜爆料 | 吃瓜爆料黑料-黑料网-吃瓜爆料黑料网 | 吃瓜爆料视频与吃瓜爆料每日大赛 | 每日热点爆料吃瓜</title>

      <HeroBanner />

      {/* Hot topics bar */}
      <section className="bg-background-100 border-b border-secondary-200/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-3">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1.5 text-accent-600 font-medium text-sm whitespace-nowrap">
              <i className="ri-fire-line"></i> 24小时热榜
            </span>
            <div className="flex-1 overflow-hidden">
              <div className="flex items-center gap-6 whitespace-nowrap animate-marquee">
                {hotArticles.map((a, idx) => (
                  <Link
                    key={a.id}
                    to={`/article/${a.id}`}
                    className="flex items-center gap-1.5 text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-200"
                  >
                    <span className="text-accent-500 font-bold text-xs">{idx + 1}</span>
                    <span>{a.title}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main content */}
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
        <div className="flex flex-col lg:flex-row gap-10">
          {/* Left: main article list */}
          <div className="flex-1 min-w-0">
            {/* Category tabs */}
            <div className="mb-8">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">
                爆料分类
              </h2>
              <CategoryTabs activeCategory={activeCategory} onCategoryChange={setActiveCategory} />
            </div>

            {/* Article grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {filteredArticles.map((article, idx) => (
                <div
                  key={article.id}
                  className="animate-fadeInUp"
                  style={{ animationDelay: `${idx * 50}ms` }}
                >
                  <ArticleCard article={article} />
                </div>
              ))}
            </div>

            {filteredArticles.length === 0 && (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-inbox-line text-3xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类下暂无内容</p>
              </div>
            )}

            {/* Load more */}
            {filteredArticles.length > 0 && (
              <div className="mt-10 text-center">
                <button className="px-8 py-3 rounded-full border border-secondary-300 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-500 transition-all duration-200 cursor-pointer whitespace-nowrap">
                  加载更多爆料
                  <i className="ri-arrow-down-line ml-2"></i>
                </button>
              </div>
            )}
          </div>

          {/* Right: sidebar */}
          <aside className="w-full lg:w-[320px] shrink-0">
            {/* Hot articles */}
            <div className="bg-background-100 rounded-lg p-5 sticky top-24">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <h3 className="text-lg font-heading font-bold text-foreground-950">热门爆料</h3>
              </div>
              <div className="flex flex-col">
                {topHotArticles.map((article, idx) => (
                  <ArticleCard key={article.id} article={article} variant="compact" />
                ))}
              </div>

              {/* Categories quick nav */}
              <div className="mt-6 pt-5 border-t border-secondary-200/60">
                <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-3">快速分类</h4>
                <div className="flex flex-wrap gap-2">
                  {categories.map((cat) => (
                    <button
                      key={cat.slug}
                      onClick={() => setActiveCategory(cat.slug)}
                      className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                        activeCategory === cat.slug
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-secondary-200/70 text-foreground-700 hover:bg-secondary-300'
                      }`}
                    >
                      {cat.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>

      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "吃瓜爆料",
          "url": "https://chigua.vercel.app",
          "description": "吃瓜爆料黑料聚合页，汇集吃瓜爆料黑料网、吃瓜爆料视频、吃瓜爆料每日大赛等热门爆料内容。",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://chigua.vercel.app/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "吃瓜爆料",
          "url": "https://chigua.vercel.app",
          "description": "吃瓜爆料是国内领先的网络热点爆料聚合平台。",
          "email": "tips@chigua-news.com"
        })}
      </script>
    </>
  );
}